/* ============================================================
   VOMAIRE Cart Drawer + Sticky ATC
   Works alongside Impulse theme.js
   ============================================================ */
(function () {
  'use strict';

  /* ---------- config injected by Liquid ---------- */
  var CFG = window.VOMAIRE_CFG || {};
  var BUNDLE = (CFG.bundle && CFG.bundle.length) ? CFG.bundle : [
    { qty: 2, off: 10 }, { qty: 3, off: 15 }, { qty: 4, off: 20 }
  ];
  var MONEY_FORMAT = CFG.moneyFormat || '${{amount}}';

  /* ---------- helpers ---------- */
  function money(cents) {
    var v = Math.abs(cents / 100);
    var s = v.toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (cents < 0 ? '-' : '') + MONEY_FORMAT.replace(/\{\{[^}]*\}\}/g, s[0] + ',' + s[1]);
  }
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function fetchJSON(url, opts) { return fetch(url, opts).then(function (r) { return r.json(); }); }

  /* ---------- bundle discount math ---------- */
  function discountFor(qty) {
    var off = 0, label = null, next = null;
    BUNDLE.forEach(function (t) { if (qty >= t.qty) { off = t.off; label = t.qty; } });
    for (var i = 0; i < BUNDLE.length; i++) { if (qty < BUNDLE[i].qty) { next = BUNDLE[i]; break; } }
    return { off: off, label: label, next: next };
  }
  /* NEED = articles encore nécessaires, ARTICLE = article/articles, NEXTOFF = remise suivante, OFF = remise atteinte */
  var DEFAULT_MSGS = [
    "Ajoutez NEED ARTICLE de plus et recevez NEXTOFF % de réduction",
    "Bon choix ! Ajoutez NEED ARTICLE de plus pour débloquer NEXTOFF % de réduction",
    "Presque ! Plus que NEED ARTICLE pour débloquer notre plus grande remise : NEXTOFF % de réduction",
    "Vous avez débloqué notre plus grande remise : OFF % sur toute votre commande"
  ];
  function nonEmpty(arr, fallback) {
    if (!arr || !arr.length) return fallback;
    return arr.map(function(v, i) { return (v && v.length) ? v : fallback[i]; });
  }

  function bundleProgressHTML(cart, compact) {
    var qty = cart.item_count;
    var disc = discountFor(qty);
    var tierLabels = nonEmpty(CFG.cartTierLabels, ['-10 % en plus','-15 % en plus','-20 % en plus']);
    var msgs = nonEmpty(CFG.cartMessages, DEFAULT_MSGS);
    var msg, tierIndex = -1;
    BUNDLE.forEach(function(t, i) { if (qty >= t.qty) tierIndex = i; });
    if (!disc.next) {
      msg = msgs[msgs.length - 1].replace('OFF', disc.off);
    } else {
      var need = disc.next.qty - qty;
      var mi = Math.max(0, Math.min(tierIndex + 1, msgs.length - 2));
      msg = msgs[mi].replace('NEED', need).replace('ARTICLE', need > 1 ? 'articles' : 'article').replace('NEXTOFF', disc.next.off);
    }
    var DOT_MAX = 88; /* max % position so dots don't hit the right edge */
    var dots = BUNDLE.map(function(t, i) {
      var active = qty >= t.qty;
      var pos = ((i + 1) / BUNDLE.length) * DOT_MAX;
      return '<div class="bprog__dot" style="left:' + pos + '%">' +
        '<div class="bprog__dot-circle ' + (active ? 'active' : '') + '">' +
          (active ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><path d="M5 12l5 5L19 7"/></svg>' : '') +
        '</div>' +
        '<span class="bprog__dot-label">' + tierLabels[i] + '</span>' +
      '</div>';
    }).join('');
    var maxQty = BUNDLE[BUNDLE.length - 1].qty;
    var pct = Math.min(100, (qty / maxQty) * 100);
    return '<div class="bprog bprog--clean' + (compact ? ' bprog--mini' : '') + '">' +
      '<div class="bprog__msg">' + msg + '</div>' +
      '<div class="bprog__bar-wrap">' +
        '<div class="bprog__track"><div class="bprog__fill" style="width:' + pct + '%"></div></div>' +
        dots +
      '</div>' +
    '</div>';
  }

  /* ---------- shipping line (same rule as checkout: threshold counts after the bundle discount) ---------- */
  var SHIP = CFG.ship || {};
  function shipCents(afterBundle) {
    var cost = Math.round(parseFloat(String(SHIP.cost == null ? '0' : SHIP.cost).replace(',', '.')) * 100) || 0;
    var from = parseFloat(String(SHIP.freeFrom == null ? '' : SHIP.freeFrom).replace(',', '.'));
    if (!cost) return 0;
    if (from > 0 && afterBundle >= Math.round(from * 100)) return 0;
    return cost;
  }

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = qs('#vomToast'); if (!t) return;
    qs('#vomToastMsg').textContent = msg;
    t.classList.add('show');
    clearTimeout(window.__vtt);
    window.__vtt = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---------- cart drawer ---------- */
  function setCounts(n) {
    qsa('[data-bag-count]').forEach(function (e) { e.textContent = n; });
    var dc = qs('#cartDrawerCount');
    if (dc) dc.textContent = n ? 'Panier • ' + n : '';
    /* also update Impulse cart bubble */
    var bubble = qs('.cart-link__bubble');
    if (bubble) {
      if (n > 0) bubble.classList.add('cart-link__bubble--visible');
      else bubble.classList.remove('cart-link__bubble--visible');
    }
  }

  function drawerLine(item) {
    var img = item.featured_image && item.featured_image.url ? item.featured_image.url : (item.image || '');
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var compareAt = item.original_price > item.final_price ? '<s>' + money(item.original_price) + '</s> ' : '';
    return '<div class="cdl" data-key="' + item.key + '">' +
      '<a href="' + item.url + '"><img class="cdl__img" src="' + img + '" alt="' + item.product_title + '" /></a>' +
      '<div class="cdl__main">' +
        '<div class="cdl__top"><div class="cdl__name">' + item.product_title + '</div>' +
        '<button class="cdl__trash" data-cd-remove="' + item.key + '" aria-label="Supprimer"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14"/></svg></button></div>' +
        (variant ? '<div class="cdl__meta">' + variant + '</div>' : '') +
        '<div class="cdl__price">' + compareAt + money(item.final_price) + (item.original_price > item.final_price ? ' <span class="cdl__save">(- ' + money(item.original_price - item.final_price) + ')</span>' : '') + '</div>' +
        '<div class="cdl__ctrls">' +
          '<div class="qty"><button data-cd-qty="' + item.key + '" data-delta="-1" aria-label="Diminuer">\u2212</button><span>' + item.quantity + '</span><button data-cd-qty="' + item.key + '" data-delta="1" aria-label="Augmenter">+</button></div>' +
        '</div>' +
      '</div></div>';
  }

  /* ---------- a pack (items added together from the bundle block) shows as ONE product ---------- */
  function packOf(item) { return item.properties && item.properties._pack ? String(item.properties._pack) : ''; }
  function drawerPack(items) {
    /* the cart lists the newest line first: reverse so #1 is the piece the customer chose first.
       line_price includes the share of cart-level discounts, so the card shows what is really paid. */
    var list = items.slice().reverse(), f = list[0], orig = 0, fin = 0, keys = [], metas = [], k = 0;
    list.forEach(function (it) { orig += it.original_line_price; fin += it.line_price; keys.push(it.key); for (var q = 0; q < it.quantity; q++) { k++; metas.push('<div class="cdl__meta">#' + k + ' ' + (it.variant_title || '') + '</div>'); } });
    var img = f.featured_image && f.featured_image.url ? f.featured_image.url : (f.image || '');
    return '<div class="cdl cdl--pack" data-pack="' + packOf(f) + '">' +
      '<a href="' + f.url + '"><img class="cdl__img" src="' + img + '" alt="' + f.product_title + '" /></a>' +
      '<div class="cdl__main">' +
        '<div class="cdl__top"><div class="cdl__name">' + f.product_title + '</div>' +
        '<button class="cdl__trash" data-cd-remove-pack="' + keys.join(',') + '" aria-label="Supprimer"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14"/></svg></button></div>' +
        metas.join('') +
        '<div class="cdl__price">' + (orig > fin ? '<s>' + money(orig) + '</s> ' : '') + money(fin) + (orig > fin ? ' <span class="cdl__save">(- ' + money(orig - fin) + ')</span>' : '') + '</div>' +
      '</div></div>';
  }
  function removePack(keys) {
    var updates = {}; keys.forEach(function (k) { updates[k] = 0; });
    return fetchJSON('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function (cart) { renderDrawer(cart); document.dispatchEvent(new CustomEvent('vomaire:cart', { detail: cart })); return cart; });
  }
  function drawerItemsHTML(cart) {
    var out = [], packs = {};
    cart.items.forEach(function (it) { var p = packOf(it); if (!p) { out.push({ single: it }); return; } if (!packs[p]) { packs[p] = { pack: [] }; out.push(packs[p]); } packs[p].pack.push(it); });
    return out.map(function (o) { return o.single ? drawerLine(o.single) : drawerPack(o.pack); }).join('');
  }
  function hasPack(cart) { return cart.items.some(function (it) { return !!packOf(it); }); }

  function renderDrawer(cart) {
    var d = qs('#cartDrawer'); if (!d) return;
    setCounts(cart.item_count);
    var body = qs('#cartDrawerBody'), foot = qs('#cartDrawerFoot');
    if (!cart.item_count) {
      body.innerHTML = '<div class="cartdrawer__empty"><p>Votre panier est vide.</p><a href="' + (CFG.shopUrl || '/collections/all') + '" class="cartdrawer__shopbtn">Découvrir la collection \u2192</a></div>';
      foot.innerHTML = '';
      return;
    }
    var disc = discountFor(cart.item_count);
    /* use Shopify's own discount when it is applied, so the drawer matches the checkout to the cent */
    var bundleSave = cart.total_discount > 0 ? cart.total_discount : Math.round(cart.items_subtotal_price * disc.off / 100);
    var afterBundle = (cart.total_discount > 0 ? cart.original_total_price : cart.items_subtotal_price) - bundleSave;
    var banner = SHIP.banner == null ? '<b>Livraison gratuite</b> à partir de 100 €' : SHIP.banner;
    var ship = SHIP.show === false ? null : shipCents(afterBundle);
    var payTotal = afterBundle + (ship && SHIP.inButton !== false ? ship : 0);
    body.innerHTML = (banner ? '<div class="cdrfree">' + banner + '</div>' : '') + (hasPack(cart) ? '' : bundleProgressHTML(cart, true)) + '<div class="cartdrawer__items">' + drawerItemsHTML(cart) + '</div>' +
      '<div class="upsell" id="drawerUpsell"></div>';
    var payTpl = qs('#cartPayMarks');
    var payHTML = payTpl ? payTpl.innerHTML : '';
    foot.innerHTML =
      '<div class="cartdrawer__rows">' +
        (disc.off ? '<div class="cdr disc"><span>Vos économies</span><span>\u2212 ' + money(bundleSave) + '</span></div>' : '') +
        (ship === null ? '' : '<div class="cdr ship"><span>' + (SHIP.label || 'Livraison') + '</span><span>' + (ship ? money(ship) : (SHIP.freeLabel || 'Gratuite')) + '</span></div>') +
        '<div class="cdr total"><span>Total</span><b>' + money(payTotal) + '</b></div>' +
      '</div>' +
      '<a href="/checkout" class="cartdrawer__checkout"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg> Paiement • ' + money(payTotal) + '</a>' + '<div class="cartdrawer__guar">Garantie de retour de 30 jours</div>' +
      payHTML;
    loadUpsell('#drawerUpsell', cart);
    /* fetch compare-at prices */
    var handles = [];
    cart.items.forEach(function(it){ if(handles.indexOf(it.handle)===-1) handles.push(it.handle); });
    Promise.all(handles.map(function(h){ return fetchJSON('/products/'+h+'.js'); }))
      .then(function(products){
        var capMap={};
        products.forEach(function(pr){ pr.variants.forEach(function(v){ capMap[v.id]=v.compare_at_price; }); });
        cart.items.forEach(function(it){
          var cap=capMap[it.variant_id];
          if(cap && cap>it.final_price){
            var el=packOf(it)?null:qs('.cdl[data-key="'+it.key+'"] .cdl__price');
            if(el) el.innerHTML='<s>'+money(cap)+'</s> '+money(it.final_price)+' <span class="cdl__save">(- '+money(cap - it.final_price)+')</span>';
          }
        });
      });
  }

  function refreshCart(open) {
    return fetchJSON('/cart.js').then(function (cart) {
      renderDrawer(cart);
      document.dispatchEvent(new CustomEvent('vomaire:cart', { detail: cart }));
      if (open) openCart();
      return cart;
    });
  }
  function openCart() { var d = qs('#cartDrawer'); if (!d) return; document.body.style.overflow = 'hidden'; requestAnimationFrame(function () { d.classList.add('open'); }); }
  function closeCart() { var d = qs('#cartDrawer'); if (d) d.classList.remove('open'); document.body.style.overflow = ''; }

  function addToCart(variantId, qty, opts) {
    opts = opts || {};
    return fetchJSON('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function () { return refreshCart(!opts.silent); });
  }
  function changeLine(key, qty) {
    return fetchJSON('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (cart) { renderDrawer(cart); document.dispatchEvent(new CustomEvent('vomaire:cart', { detail: cart })); return cart; });
  }

  /* ---------- upsell ---------- */
  function miniCard(p) {
    var v = p.variants[0];
    var compare = (v.compare_at_price && v.compare_at_price > v.price) ? '<s>' + money(v.compare_at_price) + '</s>' : '';
    var imgSrc = p.featured_image || (p.images && p.images[0]) || '';
    /* ensure Shopify CDN image is sized correctly */
    if (imgSrc && imgSrc.indexOf('cdn.shopify.com') > -1) {
      imgSrc = imgSrc.replace(/(\.[a-z]+)\?/, '_300x$1?');
      if (imgSrc.indexOf('?') === -1 && imgSrc.indexOf('_300x') === -1) {
        imgSrc = imgSrc.replace(/(\.[a-z]+)$/, '_300x$1');
      }
    }
    return '<div class="umini">' +
      '<a href="' + p.url + '"><img class="umini__img" src="' + imgSrc + '" alt="' + p.title + '" loading="lazy" /></a>' +
      '<a class="umini__name" href="' + p.url + '">' + p.title + '</a>' +
      '<div class="umini__price">' + money(v.price) + ' ' + compare + '</div>' +
      '<button class="umini__add" data-add-variant="' + v.id + '">Ajouter</button>' +
    '</div>';
  }
  function loadUpsell(sel, cart) {
    var host = qs(sel); if (!host) return;
    var pid = cart && cart.items && cart.items[0] ? cart.items[0].product_id : null;
    if (!pid) { host.innerHTML = ''; return; }
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.products || []).filter(function (p) { return p.available; });
        if (!prods.length) { host.innerHTML = ''; return; }
        host.innerHTML = '<div class="upsell__head"><span class="upsell__title">Vous aimerez aussi</span></div>' +
          '<div class="upsell__track">' + prods.map(miniCard).join('') + '</div>';
      }).catch(function () { host.innerHTML = ''; });
  }

  /* ---------- delegated events for cart drawer ---------- */
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-open-cart]'))) { e.preventDefault(); refreshCart(true); }
    else if ((t = e.target.closest('[data-close-cart]'))) { e.preventDefault(); closeCart(); }
    else if ((t = e.target.closest('[data-checkout]'))) { e.preventDefault(); window.location.href = '/checkout'; }
    else if ((t = e.target.closest('[data-add-variant]'))) { e.preventDefault(); addToCart(t.getAttribute('data-add-variant'), 1); }
    else if ((t = e.target.closest('[data-cd-qty]'))) {
      var line = t.closest('.cdl'); var span = qs('.qty span', line);
      var cur = parseInt(span.textContent, 10); var d = parseInt(t.getAttribute('data-delta'), 10);
      changeLine(t.getAttribute('data-cd-qty'), Math.max(0, cur + d));
    }
    else if ((t = e.target.closest('[data-cd-remove-pack]'))) { removePack(t.getAttribute('data-cd-remove-pack').split(',')); }
    else if ((t = e.target.closest('[data-cd-remove]'))) { changeLine(t.getAttribute('data-cd-remove'), 0); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  /* ---------- intercept ALL cart links ---------- */
  document.addEventListener('click', function (e) {
    var t;
    /* SECURE CHECKOUT link — let it navigate to /checkout */
    if ((t = e.target.closest('.cartdrawer__checkout'))) {
      e.stopPropagation();
      window.location.href = '/checkout';
      return;
    }
    /* Cart icon (.js-drawer-open-cart) */
    if ((t = e.target.closest('.js-drawer-open-cart'))) {
      e.preventDefault();
      e.stopPropagation();
      refreshCart(true);
      return;
    }
    /* Any <a> going to /cart */
    if ((t = e.target.closest('a'))) {
      var href = t.getAttribute('href') || '';
      if (href === '/cart' || href.match(/\/cart(\?|$)/)) {
        e.preventDefault();
        e.stopPropagation();
        refreshCart(true);
        return;
      }
    }
  }, true); /* capture phase — runs before Impulse */

  /* ---------- after Impulse adds product: open Vomaire drawer ---------- */
  document.addEventListener('ajaxProduct:added', function () {
    /* Close Impulse drawer if it opened */
    var impulseDrawer = document.getElementById('CartDrawer');
    if (impulseDrawer) impulseDrawer.classList.remove('drawer--is-open');
    document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open-cart');
    /* Open Vomaire drawer */
    refreshCart(true);
  });

  /* ---------- /cart page redirect ---------- */
  function redirectCartPage() {
    if (window.location.pathname === '/cart') {
      window.location.replace('/collections/all');
    }
  }

  /* ---------- expose ---------- */
  window.Vomaire = {
    money: money, addToCart: addToCart, refreshCart: refreshCart, openCart: openCart, closeCart: closeCart,
    discountFor: discountFor, bundleProgressHTML: bundleProgressHTML, toast: toast, miniCard: miniCard,
    loadUpsell: loadUpsell, fetchJSON: fetchJSON, BUNDLE: BUNDLE
  };

  /* ---------- init ---------- */
  function init() {
    redirectCartPage();
    refreshCart(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
